import React, { useRef } from 'react';
import { 
  Grid, 
  Typography, 
  Button,
  TextField, 
  Card, 
  CardContent, 
  Box,
  IconButton,
  Alert
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const PaymentDetailsForm = ({ 
  paymentTerms, 
  installmentYears, 
  setInstallmentYears, 
  formData, 
  handleInputChange, 
  firstPaymentDate, 
  setFirstPaymentDate, 
  installments = [], 
  loading = false,
  buttonText = "Continue to Personal Information",
  onButtonClick,
  showInstallmentSchedule = true,
  formErrors = {},
  handleFirstPaymentDateChange,
  showButton = true,
  onExcelUpload,
  excelFile = null,
  excelParsingError = '',
  onInstallmentUpdate,
  maintenanceInstallments = [],
  onMaintenanceInstallmentUpdate
}) => {
  const excelFileInputRef = useRef(null);
  return (
    <Grid container spacing={4}>
      {/* Installment Duration Selection */}
      <Grid item size={{ xs: 12, md: 12 }}>
        <Card sx={{ 
          borderRadius: 2,
          background: '#f8f9fa',
          border: '1px solid #e9ecef'
        }}>
          {/* <CardContent sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ 
              fontWeight: 600, 
              mb: 3,
              color: '#465064',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              ⏰ Choose Installment Duration
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
              {[6, 7, 8, 10].map((year) => (
                <Button
                  key={year}
                  variant={installmentYears === year ? 'contained' : 'outlined'}
                  onClick={() => setInstallmentYears(year)}
                  disabled={loading || !!excelFile}
                  sx={{ 
                    minWidth: 120,
                    py: 1.5,
                    px: 3,
                    fontWeight: 600,
                    borderRadius: 2,
                    fontSize: '1rem',
                    background: installmentYears === year 
                      ? '#465064' 
                      : 'transparent',
                    borderColor: installmentYears === year ? 'transparent' : '#465064',
                    color: installmentYears === year ? 'white' : '#465064',
                    '&:hover': {
                      background: installmentYears === year 
                        ? '#3a4354' 
                        : 'rgba(70, 80, 100, 0.1)'
                    }
                  }}
                >
                  {year} Years
                </Button>
              ))}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
                <Typography variant="body2" sx={{ color: '#6c757d', fontWeight: 500 }}>
                  OR
                </Typography>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  disabled={loading}
                  sx={{
                    py: 1.5,
                    px: 3,
                    fontWeight: 600,
                    borderRadius: 2,
                    borderColor: excelFile ? '#28a745' : '#465064',
                    color: excelFile ? '#28a745' : '#465064',
                    backgroundColor: excelFile ? 'rgba(40, 167, 69, 0.1)' : 'transparent',
                    '&:hover': {
                      borderColor: excelFile ? '#28a745' : '#465064',
                      backgroundColor: excelFile ? 'rgba(40, 167, 69, 0.2)' : 'rgba(70, 80, 100, 0.1)'
                    }
                  }}
                >
                  {excelFile ? 'Excel Uploaded' : 'Upload Excel'}
                  <input
                    type="file"
                    ref={excelFileInputRef}
                    hidden
                    accept=".xlsx,.xls"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file && onExcelUpload) {
                        onExcelUpload(file);
                      }
                    }}
                  />
                </Button>
                {excelFile && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
                    <Typography variant="body2" sx={{ color: '#28a745', fontWeight: 500 }}>
                      {excelFile.name}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (excelFileInputRef.current) {
                          excelFileInputRef.current.value = '';
                        }
                        if (onExcelUpload) {
                          onExcelUpload(null);
                        }
                      }}
                      sx={{ color: '#dc3545' }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Box>
            {excelParsingError && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {excelParsingError}
              </Alert>
            )}
            {excelFile && !excelParsingError && (
              <Alert severity="info" sx={{ mt: 2 }}>
                Excel file loaded successfully. Installments from Excel will be used instead of calculated values.
              </Alert>
            )}
          </CardContent> */}
        </Card>
      </Grid>

      {/* Payment Date Selection */}
     

      {/* Installment Schedule */}
      {/* {showInstallmentSchedule && installments.length > 0 && (
        <Grid item size={{ xs: 12, md: 12 }}>
          <Card sx={{ 
            borderRadius: 2,
            background: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ 
                fontWeight: 600, 
                mb: 3,
                color: '#465064',
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}>
                📋 Installment Schedule {onInstallmentUpdate && <Typography variant="body2" sx={{ color: '#6c757d', fontWeight: 400, ml: 1 }}>(Editable)</Typography>}
              </Typography>
              <Box sx={{ 
                height: 400, 
                width: '100%', 
                overflowX: 'auto', 
                background: 'white', 
                borderRadius: 2, 
                boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
                p: 1 
              }}>
                <Box sx={{ minWidth: 500 }}>
                  <DataGrid
                    rows={installments.map((row, index) => {
                      // Ensure rawDate is in YYYY-MM-DD format for date editing
                      let rawDateStr = row.rawDate;
                      if (!rawDateStr && row.dueDate) {
                        const date = new Date(row.dueDate);
                        if (!isNaN(date.getTime())) {
                          const year = date.getFullYear();
                          const month = String(date.getMonth() + 1).padStart(2, '0');
                          const day = String(date.getDate()).padStart(2, '0');
                          rawDateStr = `${year}-${month}-${day}`;
                        }
                      }
                      
                      // Ensure all required fields are present
                      const amountValue = row.rawAmount !== undefined ? row.rawAmount : (() => {
                        if (typeof row.amount === 'number') return row.amount;
                        if (typeof row.amount === 'string') {
                          return parseFloat(row.amount.replace(/[^\d.-]/g, '') || '0') || 0;
                        }
                        return 0;
                      })();
                      
                      const numberValue = row.number || row.installmentNumber || `Installment ${index + 1}`;
                      
                      return {
                        id: row.id || index + 1,
                        number: numberValue,
                        dueDate: row.dueDate || '',
                        amount: typeof row.amount === 'string' ? row.amount : amountValue.toLocaleString(undefined, { maximumFractionDigits: 2 }),
                        // Store date as string in YYYY-MM-DD format for editing
                        dueDateEdit: rawDateStr || '',
                        rawDate: rawDateStr || row.rawDate || '',
                        // Use rawAmount for editing, display formatted amount
                        amountEdit: amountValue,
                        rawAmount: amountValue
                      };
                    })}
                    columns={[
                      { 
                        field: 'number', 
                        headerName: 'Installment #', 
                        width: 160,
                        headerClassName: 'custom-header',
                        editable: false
                      },
                      { 
                        field: 'dueDateEdit', 
                        headerName: 'Payment Date', 
                        width: 200,
                        headerClassName: 'custom-header',
                        editable: !!onInstallmentUpdate,
                        type: 'date',
                        valueGetter: (value, row) => {
                          // Convert string date to Date object for MUI X DataGrid
                          if (row.dueDateEdit) {
                            const date = new Date(row.dueDateEdit);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          if (row.rawDate) {
                            const date = new Date(row.rawDate);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          if (row.dueDate) {
                            const date = new Date(row.dueDate);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          return null;
                        },
                        valueSetter: (params) => {
                          // Handle both Date objects and string dates
                          let newDateStr = '';
                          if (params.value instanceof Date) {
                            const year = params.value.getFullYear();
                            const month = String(params.value.getMonth() + 1).padStart(2, '0');
                            const day = String(params.value.getDate()).padStart(2, '0');
                            newDateStr = `${year}-${month}-${day}`;
                          } else if (typeof params.value === 'string') {
                            newDateStr = params.value;
                          } else {
                            return params.row;
                          }
                          
                          const dateObj = new Date(newDateStr);
                          return {
                            ...params.row,
                            rawDate: newDateStr,
                            dueDate: dateObj.toLocaleDateString(),
                            dueDateEdit: newDateStr
                          };
                        },
                        renderCell: (params) => {
                          const row = params.row;
                          if (row.dueDate) {
                            return row.dueDate;
                          }
                          if (row.dueDateEdit) {
                            const date = new Date(row.dueDateEdit);
                            return isNaN(date.getTime()) ? row.dueDateEdit : date.toLocaleDateString();
                          }
                          if (row.rawDate) {
                            const date = new Date(row.rawDate);
                            return isNaN(date.getTime()) ? row.rawDate : date.toLocaleDateString();
                          }
                          return '';
                        }
                      },
                      { 
                        field: 'amountEdit', 
                        headerName: 'Amount (EGP)', 
                        width: 180,
                        headerClassName: 'custom-header',
                        editable: !!onInstallmentUpdate,
                        type: 'number',
                        valueGetter: (value, row) => row.amountEdit || 0,
                        valueSetter: (params) => {
                          const newAmount = parseFloat(params.value) || 0;
                          return {
                            ...params.row,
                            rawAmount: newAmount,
                            amount: newAmount.toLocaleString(undefined, { maximumFractionDigits: 2 }),
                            amountEdit: newAmount
                          };
                        },
                        renderCell: (params) => {
                          const row = params.row;
                          const amount = row.amountEdit || row.rawAmount || 0;
                          return `${amount.toLocaleString(undefined, { maximumFractionDigits: 2 })} EGP`;
                        }
                      },
                    ]}
                    processRowUpdate={(newRow) => {
                      // Update the installments when a cell is edited
                      const updatedRows = installments.map(row => {
                        if (row.id === newRow.id) {
                          return {
                            ...row,
                            rawDate: newRow.rawDate || newRow.dueDateEdit,
                            rawAmount: newRow.rawAmount !== undefined ? newRow.rawAmount : newRow.amountEdit,
                            dueDate: newRow.dueDate || (newRow.dueDateEdit ? new Date(newRow.dueDateEdit).toLocaleDateString() : row.dueDate),
                            amount: newRow.amount || (newRow.amountEdit ? newRow.amountEdit.toLocaleString(undefined, { maximumFractionDigits: 2 }) : row.amount)
                          };
                        }
                        return row;
                      });
                      if (onInstallmentUpdate) {
                        onInstallmentUpdate(updatedRows);
                      }
                      return {
                        ...newRow,
                        rawDate: newRow.rawDate || newRow.dueDateEdit,
                        rawAmount: newRow.rawAmount !== undefined ? newRow.rawAmount : newRow.amountEdit,
                        dueDate: newRow.dueDate || (newRow.dueDateEdit ? new Date(newRow.dueDateEdit).toLocaleDateString() : ''),
                        amount: newRow.amount || (newRow.amountEdit ? newRow.amountEdit.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '')
                      };
                    }}
                    onProcessRowUpdateError={(error) => {
                      console.error('Error updating row:', error);
                    }}
                    disableSelectionOnClick
                    autoHeight
                    hideFooter
                    hideFooterPagination
                    hideFooterSelectedRowCount
                    editMode="cell"
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#465064',
                        color: 'white',
                        fontWeight: 600
                      },
                      '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #e0e0e0'
                      },
                      '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f5f5f5'
                      },
                      '& .MuiDataGrid-cell:focus': {
                        outline: '2px solid #465064',
                        outlineOffset: '-2px'
                      },
                      '& .MuiDataGrid-cell:focus-within': {
                        outline: '2px solid #465064',
                        outlineOffset: '-2px'
                      },
                      '& .MuiDataGrid-cell--editing': {
                        backgroundColor: '#fff9e6'
                      }
                    }}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )} */}

      {/* Maintenance Deposit Schedule */}
      {(() => {
        console.log('PaymentDetailsForm - maintenanceInstallments:', maintenanceInstallments, 'length:', maintenanceInstallments?.length);
        return maintenanceInstallments && maintenanceInstallments.length > 0;
      })() && (
        <Grid item size={{ xs: 12, md: 12 }}>
          <Card sx={{ 
            borderRadius: 2,
            background: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ 
                fontWeight: 600, 
                mb: 3,
                color: '#465064',
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}>
                🏠 Maintenance Deposit Schedule {onMaintenanceInstallmentUpdate && <Typography variant="body2" sx={{ color: '#6c757d', fontWeight: 400, ml: 1 }}>(Editable)</Typography>}
              </Typography>
              <Box sx={{ 
                height: 400, 
                width: '100%', 
                overflowX: 'auto', 
                background: 'white', 
                borderRadius: 2, 
                boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
                p: 1 
              }}>
                <Box sx={{ minWidth: 500 }}>
                  <DataGrid
                    rows={maintenanceInstallments.map((row, index) => {
                      // Ensure rawDate is in YYYY-MM-DD format for date editing
                      let rawDateStr = row.rawDate;
                      if (!rawDateStr && row.dueDate) {
                        const date = new Date(row.dueDate);
                        if (!isNaN(date.getTime())) {
                          const year = date.getFullYear();
                          const month = String(date.getMonth() + 1).padStart(2, '0');
                          const day = String(date.getDate()).padStart(2, '0');
                          rawDateStr = `${year}-${month}-${day}`;
                        }
                      }
                      
                      // Ensure all required fields are present
                      const amountValue = row.rawAmount !== undefined ? row.rawAmount : (() => {
                        if (typeof row.amount === 'number') return row.amount;
                        if (typeof row.amount === 'string') {
                          return parseFloat(row.amount.replace(/[^\d.-]/g, '') || '0') || 0;
                        }
                        return 0;
                      })();
                      
                      const numberValue = row.number || `Maintenance ${index + 1}`;
                      
                      return {
                        id: row.id || index + 1,
                        number: numberValue,
                        dueDate: row.dueDate || '',
                        amount: typeof row.amount === 'string' ? row.amount : amountValue.toLocaleString(undefined, { maximumFractionDigits: 2 }),
                        // Store date as string in YYYY-MM-DD format for editing
                        dueDateEdit: rawDateStr || '',
                        rawDate: rawDateStr || row.rawDate || '',
                        // Use rawAmount for editing, display formatted amount
                        amountEdit: amountValue,
                        rawAmount: amountValue
                      };
                    })}
                    columns={[
                      { 
                        field: 'number', 
                        headerName: 'Installment #', 
                        width: 160,
                        headerClassName: 'custom-header',
                        editable: false
                      },
                      { 
                        field: 'dueDateEdit', 
                        headerName: 'Payment Date', 
                        width: 200,
                        headerClassName: 'custom-header',
                        editable: !!onMaintenanceInstallmentUpdate,
                        type: 'date',
                        valueGetter: (value, row) => {
                          // Convert string date to Date object for MUI X DataGrid
                          if (row.dueDateEdit) {
                            const date = new Date(row.dueDateEdit);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          if (row.rawDate) {
                            const date = new Date(row.rawDate);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          if (row.dueDate) {
                            const date = new Date(row.dueDate);
                            return isNaN(date.getTime()) ? null : date;
                          }
                          return null;
                        },
                        valueSetter: (params) => {
                          // Handle both Date objects and string dates
                          let newDateStr = '';
                          if (params.value instanceof Date) {
                            const year = params.value.getFullYear();
                            const month = String(params.value.getMonth() + 1).padStart(2, '0');
                            const day = String(params.value.getDate()).padStart(2, '0');
                            newDateStr = `${year}-${month}-${day}`;
                          } else if (typeof params.value === 'string') {
                            newDateStr = params.value;
                          } else {
                            return params.row;
                          }
                          
                          const dateObj = new Date(newDateStr);
                          return {
                            ...params.row,
                            rawDate: newDateStr,
                            dueDate: dateObj.toLocaleDateString(),
                            dueDateEdit: newDateStr
                          };
                        },
                        renderCell: (params) => {
                          const row = params.row;
                          if (row.dueDate) {
                            return row.dueDate;
                          }
                          if (row.dueDateEdit) {
                            const date = new Date(row.dueDateEdit);
                            return isNaN(date.getTime()) ? row.dueDateEdit : date.toLocaleDateString();
                          }
                          if (row.rawDate) {
                            const date = new Date(row.rawDate);
                            return isNaN(date.getTime()) ? row.rawDate : date.toLocaleDateString();
                          }
                          return '';
                        }
                      },
                      { 
                        field: 'amountEdit', 
                        headerName: 'Amount (EGP)', 
                        width: 180,
                        headerClassName: 'custom-header',
                        editable: !!onMaintenanceInstallmentUpdate,
                        type: 'number',
                        valueGetter: (value, row) => row.amountEdit || 0,
                        valueSetter: (params) => {
                          const newAmount = parseFloat(params.value) || 0;
                          return {
                            ...params.row,
                            rawAmount: newAmount,
                            amount: newAmount.toLocaleString(undefined, { maximumFractionDigits: 2 }),
                            amountEdit: newAmount
                          };
                        },
                        renderCell: (params) => {
                          const row = params.row;
                          const amount = row.amountEdit || row.rawAmount || 0;
                          return `${amount.toLocaleString(undefined, { maximumFractionDigits: 2 })} EGP`;
                        }
                      },
                    ]}
                    processRowUpdate={(newRow) => {
                      // Update the installments when a cell is edited
                      const updatedRows = maintenanceInstallments.map(row => {
                        if (row.id === newRow.id) {
                          return {
                            ...row,
                            rawDate: newRow.rawDate || newRow.dueDateEdit,
                            rawAmount: newRow.rawAmount !== undefined ? newRow.rawAmount : newRow.amountEdit,
                            dueDate: newRow.dueDate || (newRow.dueDateEdit ? new Date(newRow.dueDateEdit).toLocaleDateString() : row.dueDate),
                            amount: newRow.amount || (newRow.amountEdit ? newRow.amountEdit.toLocaleString(undefined, { maximumFractionDigits: 2 }) : row.amount)
                          };
                        }
                        return row;
                      });
                      if (onMaintenanceInstallmentUpdate) {
                        onMaintenanceInstallmentUpdate(updatedRows);
                      }
                      return {
                        ...newRow,
                        rawDate: newRow.rawDate || newRow.dueDateEdit,
                        rawAmount: newRow.rawAmount !== undefined ? newRow.rawAmount : newRow.amountEdit,
                        dueDate: newRow.dueDate || (newRow.dueDateEdit ? new Date(newRow.dueDateEdit).toLocaleDateString() : ''),
                        amount: newRow.amount || (newRow.amountEdit ? newRow.amountEdit.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '')
                      };
                    }}
                    onProcessRowUpdateError={(error) => {
                      console.error('Error updating maintenance row:', error);
                    }}
                    disableSelectionOnClick
                    autoHeight
                    hideFooter
                    hideFooterPagination
                    hideFooterSelectedRowCount
                    editMode="cell"
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#465064',
                        color: 'white',
                        fontWeight: 600
                      },
                      '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #e0e0e0'
                      },
                      '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f5f5f5'
                      },
                      '& .MuiDataGrid-cell:focus': {
                        outline: '2px solid #465064',
                        outlineOffset: '-2px'
                      },
                      '& .MuiDataGrid-cell:focus-within': {
                        outline: '2px solid #465064',
                        outlineOffset: '-2px'
                      },
                      '& .MuiDataGrid-cell--editing': {
                        backgroundColor: '#fff9e6'
                      }
                    }}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}

      {/* Action Button */}
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button 
          variant="contained" 
          size="large" 
          onClick={onButtonClick}
          disabled={!showButton || loading}
          sx={{ 
            px: 6, 
            py: 2, 
            fontWeight: 600,
            fontSize: '1.1rem',
            borderRadius: 2,
            background: '#465064',
            boxShadow: '0 2px 8px rgba(70, 80, 100, 0.15)',
            '&:hover': {
              background: '#3a4354',
              boxShadow: '0 4px 12px rgba(70, 80, 100, 0.2)',
              transform: 'translateY(-2px)'
            },
            transition: 'all 0.2s ease'
          }}
        >
          🚀 {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PaymentDetailsForm; 